import { useMutation, useQueryClient } from 'react-query';
import { ServerStateKeysEnum } from 'reactQuery/constants';
import { cartService } from 'services';
import { displayNotification, pushToGTM } from 'utils';
import { useI18n } from 'contexts/i18n';
import { Cart } from 'types';
import { AxiosError } from 'axios';

export const useProceedToCheckout = (
  setStockError: (value: any) => void
) => {
  const queryClient = useQueryClient();
  const i18n = useI18n();
  return useMutation(
    () => {
      return cartService.proceedToCheckout();
    },
    {
      onSuccess: (data, variables, context) => {
        queryClient.setQueriesData([ServerStateKeysEnum.userCurrentCart], data);
        pushCheckoutEventToGTM(data);
      },
      onError: (
        error: AxiosError<{
          error?: string;
        }>
      ) => {
        const err = error?.response?.data?.error;
        if (err) {
          setStockError(err);
        } else {
          displayNotification(
            i18n['Something went wrong, Please refresh the page!'],
            'danger'
          );
        }
      },
    }
  );
};

const pushCheckoutEventToGTM = (data: Cart) => {
  const lineItems = data.lineItems.map(currentLineItem => {
    return {
      item_id: currentLineItem.slug,
      item_name: currentLineItem.name,
      affiliation: 'Global Store NA',
      price: currentLineItem.price,
      currency: data.currency,
      quantity: currentLineItem.quantity,
    };
  });

  pushToGTM('begin_checkout', {
    ecommerce: {
      currency: data.currency,
      value: data.total,
      items: lineItems,
    },
  });
};
